import { Component, ElementRef, Inject, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ZipFileDownloadDialog } from 'src/app/zip-file-download/zip-file-download-dialog.component';

@Component({
  selector: 'app-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss']
})
export class CustomSnackbarComponent {
  icon: string = '';
  title: string = '';

  constructor(private snackBarRef: MatSnackBarRef<CustomSnackbarComponent>, @Inject(MAT_SNACK_BAR_DATA) public data: any, private router: Router, public dialog: MatDialog, private renderer: Renderer2, private el: ElementRef) {

  }

  ngOnInit(): void {
    this.setAttributes();
    this.setDynamicStyles()
  }
  closeSnackbar() {
    this.snackBarRef.dismiss();
  }
  navigateToDashboard() {
    this.snackBarRef.dismiss();
    let dialogRef;
    dialogRef = this.dialog.open(ZipFileDownloadDialog, {
      width: '635px',
    });

  }

  setAttributes(): void {
    const attributes = {
      ERROR: { icon: 'close', title: 'Error!' },
      INFO: { icon: 'info', title: 'Information!' },
      SUCCESS: { icon: 'check', title: 'Success!' },
      DOWNLOAD: { icon: 'arrow_downward_alt', title: 'Download!' },
      WARNING: { icon: 'error', title: 'Warning!' },
      DEFAULT: { icon: '', title: '' },
    };

    const type = this.data?.type || 'DEFAULT';
    const { icon, title } = attributes[type] || attributes.DEFAULT;

    this.icon = icon;
    this.title = title;
  }


  setDynamicStyles(): void {
    const styles = {
      ERROR: { borderColor: '#ff8194', bgColor: '#ff8194', wrapperColor: '#ffcad2', iconColor: '#ff4567' },
      INFO: { borderColor: '#60f8ff', bgColor: '#60f8ff', wrapperColor: '#c8f7f9', iconColor: '#00a3cc' },
      SUCCESS: { borderColor: '#63cf64', bgColor: '#63cf64', wrapperColor: '#c8e9c8', iconColor: '#008000' },
      DOWNLOAD: { borderColor: '#7684ff', bgColor: '#7684ff', wrapperColor: '#c4caff', iconColor: '#0000ff' },
      WARNING: { borderColor: '#ffcd68', bgColor: '#ffcd68', wrapperColor: '#fff3d0', iconColor: '#F8AB11' },
    };

    const typeStyles = styles[this.data?.type] || {};
    const wrapper = this.el.nativeElement.querySelector('.custom-snackbar-wrapper');
    const iconWrapper = this.el.nativeElement.querySelector('.snackbar-icon-wrapper');
    const icon = this.el.nativeElement.querySelector('.snackbar-icon');

    // Set the border color for the wrapper
    if (wrapper && typeStyles.borderColor) {
      this.renderer.setStyle(wrapper, 'border-left', `5px solid ${typeStyles.borderColor}`);
    }

    // Set the background color for the icon wrapper
    if (iconWrapper && typeStyles.bgColor) {
      this.renderer.setStyle(iconWrapper, 'background-color', typeStyles.bgColor);
    }

    // Set the background color for the entire wrapper
    if (wrapper && typeStyles.wrapperColor) {
      this.renderer.setStyle(wrapper, 'background-color', typeStyles.wrapperColor);
    }

    // Set the color for the icon
    if (icon && typeStyles.iconColor) {
      this.renderer.setStyle(icon, 'color', typeStyles.iconColor);
    }
  }
}
